import type { RouteObject } from 'react-router';

import { DeviceRevokedPage } from '@/pages/errors/DeviceRevokedPage';
import { ForbiddenPage } from '@/pages/errors/ForbiddenPage';
import { NotFoundPage } from '@/pages/errors/NotFoundPage';

export const errorRoutes: RouteObject[] = [
  { path: 'device-revoked', Component: DeviceRevokedPage, handle: { title: 'Signed out' } },
  { path: 'forbidden', Component: ForbiddenPage, handle: { title: 'No access' } },
  { path: '*', Component: NotFoundPage, handle: { title: 'Not found' } },
];
